var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('notifications',{staticClass:"mt-4",attrs:{"group":"foo","position":"top center"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }